import React, { useEffect, useState } from "react";

import dayjs from "dayjs";

import IngestionApi from "apis/ingestion";

import ActionHeader from "./ActionHeader";
import COLUMN_DATA from "./column";
import DeleteFiles from "./DeleteFiles";
import FilesTable from "./FilesTable";
import PrimaryHeader from "./PrimaryHeader";
import UploadFilePane from "./UploadFilePane";

const UploadFromLocal = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [search, setSearch] = useState("");
  const [checkedRows, setCheckedRows] = useState([]);
  const [isUploadPaneOpen, setIsUploadPaneOpen] = useState(false);
  const [isDeleteAlertOpen, setIsDeleteAlertOpen] = useState(false);

  const fetchFiles = async () => {
    try {
      setIsLoading(true);
      const { data } = await IngestionApi.fetchFiles();
      setFiles({ count: data.length, data: handleFilesList(data) });
    } catch (error) {
      logger.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => fetchFiles(), []);

  const handleFilesList = files =>
    files.map(
      ({ fileName, creationTime, lastModified, contentLength }, index) => {
        const currentFileName = fileName.substring(
          fileName.lastIndexOf("/") + 1
        );
        return {
          id: index,
          fileName: currentFileName || `File ${index + 1}`,
          creationDate: dayjs(creationTime),
          lastModified: dayjs(lastModified),
          size: contentLength,
        };
      }
    );

  return (
    <div className="cs-ui-container cs-ui-container__table">
      <PrimaryHeader setIsUploadPaneOpen={setIsUploadPaneOpen} />

      {files?.count > 0 && (
        <ActionHeader
          search={search}
          setSearch={setSearch}
          totalCount={files.count}
          setIsDeleteAlertOpen={setIsDeleteAlertOpen}
          checkedRows={checkedRows}
        />
      )}
      <FilesTable
        columns={COLUMN_DATA}
        files={files}
        isLoading={isLoading}
        checkedRows={checkedRows}
        setCheckedRows={setCheckedRows}
        openUploadPane={() => setIsUploadPaneOpen(true)}
      />

      <UploadFilePane
        setIsUploadPaneOpen={setIsUploadPaneOpen}
        isUploadPaneOpen={isUploadPaneOpen}
        fetchFiles={fetchFiles}
      />
      <DeleteFiles
        checkedRows={checkedRows}
        isDeleteAlertOpen={isDeleteAlertOpen}
        setIsDeleteAlertOpen={setIsDeleteAlertOpen}
        setCheckedRows={setCheckedRows}
        setIsLoading={setIsLoading}
        fetchFiles={fetchFiles}
      />
    </div>
  );
};

export default UploadFromLocal;
